import { queryFetch } from '@services/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { NotificationResp } from './types';

export const useClearNotifications = ({
  callback,
}: {
  callback: (data: NotificationResp) => void;
}) => {
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: (): Promise<NotificationResp> =>
      queryFetch({ url: `notifications/clear_all`, opt: { method: 'POST' } }),
    onError: (err) => {
      console.error(err);
    },
    onSuccess: async ({ success }) => {
      if (success) await queryClient.refetchQueries({ queryKey: queryKeys.notifications });
    },
    onSettled: (data) => {
      if (data) callback(data);
    },
  });

  return {
    mutate,
    isLoading: isPending,
  };
};
